import "moment/locale/it"
import { CompetitionSeasonPlayerCompetitionSeasonParameterFlat } from "../../../types/competitionSeasonPlayerStats"
import { PlayerCompetitionSeasonStats } from "@components/CompetitionSeasonStats/PlayerCompetitionSeasonStats"
import { PlayerRole } from "../../../types/player"

export function PlayerCompetitionSeasonsStats({
  role,
  stats,
}: {
  role: PlayerRole | null
  stats: CompetitionSeasonPlayerCompetitionSeasonParameterFlat
}) {
  return <PlayerCompetitionSeasonStats role={role} stats={stats} />
}
